import { useState } from "react";
import { AppInformation } from "./Tabs/AppInformation";
import { ManageApp } from "./Tabs/ManageApp";
import { useSelector } from "react-redux";

export const ViewProduct = () => {
  const [subTab, setsubTab] = useState(1);

  const { viewData } = useSelector((store) => store.dashboard);
  const [success, setsuccess] = useState(viewData?.client_id ? true : false);
  const [authData, setauthData] = useState({
    client_id: viewData?.client_id,
    client_secret: viewData?.client_secret,
  });
  const [data, setDAta] = useState({});

  const [copy, setcopy] = useState(false);

  return (
    <>
      <div
        style={{
          overflow: "auto",
        }}
        className="dashboard"
      >
        <div className="dashboard__body">
          <div className="dashboard__body__header">
            <h1 className="title">All Apps</h1>
          </div>
          <div className="whiteBox whiteBox--appdetail">
            <div className="whiteBox__databox">
              <div className="basicCard">
                <h2 className="title title--h2">Basic Information</h2>
                <p className="para">
                  App Name:{" "}
                  <span className="para__text">
                    {data?.app_name ? data?.app_name : viewData?.app_name}
                  </span>
                </p>
                <p className="para">
                  Client Id:{" "}
                  <span className="para__text">
                    {authData?.client_id
                      ? authData?.client_id
                      : viewData?.client_id
                        ? viewData?.client_id
                        : "XXXXXXX"}
                  </span>
                </p>
              </div>
              <div className="commonBox">
                <ul className="tabs">
                  <li
                    onClick={() => {
                      setsubTab(1);
                    }}
                    className={`tab-link ${subTab === 1 && `current`}`}
                    data-tab="tab1"
                  >
                    App Information
                  </li>
                  <li
                    onClick={() => {
                      setsubTab(2);
                    }}
                    className={`tab-link ${subTab === 2 && `current`}`}
                    data-tab="tab2"
                  >
                    Security Credentials
                  </li>
                </ul>
                <div className="tab-contents">
                  {subTab === 1 && (
                    <AppInformation
                      data={data}
                      setDAta={setDAta}
                      subTab={subTab}
                    />
                  )}
                  {subTab === 2 && (
                    <ManageApp
                      subTab={subTab}
                      success={success}
                      setsuccess={setsuccess}
                      setauthData={setauthData}
                      authData={authData}
                      setcopy={setcopy}
                      copy={copy}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
